import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { getSeoDataApi } from "../../../api/seo/seo";
import { OrderFlow } from "../../../../src/App";
import { getFooter } from "../../../actions/home/footerAction";
import { useSelector } from "react-redux";
import { getHomepage } from "../../../actions/home/homepageActions";
import Footer from "../../../common/restuarant/footer/footer";
import LeadForm from "./LeadForm";
import "../home/home_f.scss";
import { Button, Col, Container, Row } from "react-bootstrap";
import { IoArrowBackCircleOutline } from "react-icons/io5";


const BecomeFranchisePage = ({
    getFooter,
    getSeoDataApi,
}) => {
    const [seoData, setSeoData] = useState();
    const { businessTitle } = OrderFlow();
    const location = useLocation();
    const canonicalUrl = `${window.location.origin}${location.pathname}`;
    const response = useSelector(state => state.homepage);
    const domain = window.location.hostname;
    const navigate = useNavigate();

    useEffect(() => {
        const postData = {
            domain: domain
        }
        getFooter(postData);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const formData = {
                    domain: window.location.hostname,
                };
                const apiResponse = await getSeoDataApi(formData);

                if (apiResponse?.data?.status === false) {
                    console.error("Error fetching sitemap data:", apiResponse.data.message);
                } else {
                    setSeoData(apiResponse.data.message);
                }
            } catch (error) {
                console.error("Error fetching sitemap data:", error);
            }
        };
        fetchData();
    }, []);

    const back = () => {
        navigate(-1);
    }

    return (
        <>
            <Helmet>
                <style type="text/css">
                    {`footer{ display:block;}`}
                </style>
                <link rel="canonical" href={canonicalUrl} />
                {seoData?.title?.home ? (
                    <title>{seoData.title.home}</title>
                ) : businessTitle ? (
                    <title>{businessTitle + " - Online Order"}</title>
                ) : null}
                {Array.isArray(seoData?.meta?.Home) &&
                    seoData?.meta?.Home.map((data, index) => (
                        <meta name={data.value} content={data.content} key={index} />
                    ))}
                {Array.isArray(seoData?.seo_og_details) &&
                    seoData?.seo_og_details.map((data, i) => {
                        if (data.og_title !== "og:image" && data.og_title !== "twitter:image") {
                            return <meta name={data.og_title} content={data.og_description} key={i} />;
                        }
                        return null; // Add return null to ensure no invalid return
                    })}
                {Array.isArray(seoData?.seo_og_details) &&
                    seoData?.seo_og_details.map((data, i) => {
                        if (data.og_title === "og:image" || data.og_title === "twitter:image") {
                            return <meta name={data.og_title} content={data.full_og_image} key={i} />;
                        }
                        return null; // Add return null to ensure no invalid return
                    })}
            </Helmet>
            <main className="home-page-franchise" >
                <div className="background-layer"
                    style={{
                        backgroundImage: `url(${response?.response?.data?.banner[0]?.bgImage})`
                    }} />
                <div className="foreground-content">
                    <Container>
                        <Row>
                            <Col xs={1} sm={1} md={1} lg={1} className="mt-3 rounded-full ">
                                <Button onClick={back} variant="outline">
                                    <IoArrowBackCircleOutline
                                        size={"25px"}
                                        style={{
                                            color: "#000",
                                            backgroundColor: "#fff",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px"
                                        }}
                                    />
                                </Button>
                            </Col>
                        </Row>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                            <div
                                style={{
                                    width: "480px",
                                    padding: "50px",
                                    backgroundColor: "white",
                                    margin: "50px",
                                    textWrap: 'nowrap',
                                    border: "8px double red",
                                    borderRadius: "10px"
                                }}>
                                <h1>
                                    Become a Franchise
                                </h1>
                            </div>
                        </div>
                    </Container>
                    <LeadForm />
                    <Footer />
                </div >
            </main >
        </>
    );
};
const mapStateToProps = (state) => ({
    response: state.homepage?.response,
    footer: state.footer.response,
});

const mapDispatchToProps = {
    getSeoDataApi,
    getHomepage,
    getFooter,
};

export default connect(mapStateToProps, mapDispatchToProps)(BecomeFranchisePage);

